import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsArxivComponent } from './simple-icons-arxiv.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsArxivComponent ],
    exports:      [ SimpleIconsArxivComponent ],
    bootstrap:    []
})
export class SimpleIconsArxivModule {}
